import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import DoubleClickEdit from "../../../../../components/DoubleClickEdit";
import { XCircleIcon } from "@heroicons/react/solid";
import ReactDatePicker from "react-datepicker";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { formatTaskDate } from "./taskDateFormatters";

/**
 * Inline double-click-editable "visible on" date field for a task.
 * Controls when the task becomes visible to the client. A null value
 * means "Always Visible". Displays an open-eye icon when currently visible,
 * or a closed-eye icon when the visibility date is in the future.
 * In client-portal mode renders an empty element (not shown to clients).
 *
 * @param {object}   props
 * @param {Function} props.handleSubmitEdit - Called with the new Date value (or null) on change
 * @param {boolean}  props.isClientPortal   - Renders nothing for the client-portal view
 * @param {object}   props.task             - Task object; `task.visible_on` seeds the initial value
 */
const VisibleOn = ({ handleSubmitEdit, isClientPortal, task }) => {
    const [value, setValue] = useState(task.visible_on);
    const [showEdit, setShowEdit] = useState(false);

    const handleChange = (newValue) => {
        setValue(newValue === "Always Visible" ? null : newValue);
        handleSubmitEdit(newValue);
        setShowEdit(false);
    };

    const handleClearValue = () => {
        setValue(null);
        handleSubmitEdit(null);
        setShowEdit(false);
    }

    useEffect(() => {
        setValue(task.visible_on);
    }, [task.visible_on]);

    const isVisibleNow = useMemo(() => {
        if (value === "Always Visible") return true;
        if (new Date(value).getTime() < new Date().getTime()) return true
        return false
    }, [value]);
    return (
        <>


            {isClientPortal ?

                <div className="">


                </div> :
                <DoubleClickEdit
                    showEdit={showEdit}
                    setShowEdit={setShowEdit}
                    defaultComponent={
                        <div className="flex items-center text-xs text-gray-500">
                            {value ? (
                                <>
                                    {isVisibleNow ? <FaRegEye
                                        className="mr-1 h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                                        aria-hidden="true"
                                    /> : <FaRegEyeSlash
                                        className="mr-1 h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                                        aria-hidden="true"
                                    />}
                                    <div className="group flex items-center gap-1">
                                        <span>{formatTaskDate(value)}</span>
                                        <button onClick={handleClearValue} aria-label="Clear visible on date" className="invisible group-hover:visible">
                                            <XCircleIcon className="h-3.5 w-3.5 text-gray-400" aria-hidden="true" />
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <FaRegEye
                                        className="mr-1 h-3.5 w-3.5 flex-shrink-0 text-gray-400"
                                        aria-hidden="true"
                                    />
                                    <span className="min-w-max">Visible</span>
                                </>
                            )}
                        </div>
                    }
                    editComponent={

                        <ReactDatePicker
                            className="input-primary "
                            selected={value}
                            onChange={(date) => handleChange(new Date(date))}
                        />

                    }
                    handleSubmitEdit={() => { }}
                    componentName="visible_on"
                />}
        </>
    );
};

export default VisibleOn;
